module.exports = "<div class=\"<%= title %>\" ng-if=\"$ctrl.title\">{{ $ctrl.title }}</div>\r\n<ng-transclude class=\"<%= definitionList %>\"\r\n               ng-class=\"$ctrl.title ? '<%= hasTitle %>' : ''\"></ng-transclude>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/definition-list/DefinitionList/DefinitionList.html
// module id = 908
// module chunks = 0